import './calendar.less'
// 核心
import React from 'react';
import classnames from 'classnames';
//
import Component from '../core/component';
// 工具
import {date, time, strtotime, is_int, empty} from '../libs/tools';
// 组件
import Lang from '../common/lang';
import Lock from '../common/lock'
import Icon from '../common/icon'
//import button from '../admin/button'
import Waves from '../common/waves';
import PropTypes from 'prop-types'

import debug from 'debug';

const log = debug('common.calendar')

let lang = {
    days: [
        'c.datetime.monday',
        'c.datetime.tuesday',
        'c.datetime.wednesday',
        'c.datetime.thursday',
        'c.datetime.friday',
        'c.datetime.saturday',
        'c.datetime.sunday',
    ],
    months: [
        'c.datetime.january',
        'c.datetime.february',
        'c.datetime.march',
        'c.datetime.april',
        'c.datetime.may',
        'c.datetime.june',
        'c.datetime.july',
        'c.datetime.august',
        'c.datetime.september',
        'c.datetime.october',
        'c.datetime.november',
        'c.datetime.december'
    ],
    monthsShort: ['jan', 'feb', 'mar', 'apr', 'may', 'jun', 'jul', 'aug', 'sep', 'oct', 'nov', 'dec'],
};

/**
 * 日历
 */
class Calendar extends Component {
    state = {
        year: ~~date('Y'),
        month: ~~date('m'),
        format: 'Y-m-d',
        selected: null
    };

    constructor(props, context) {
        super(props, context);
        $.extend(this.state, props);
    }

    /**
     * componentDidMount()在挂载结束之后马上被调用。需要DOM节点的初始化操作应该放在这里。
     */
    componentDidMount() {
        if (!empty(this.state.value)) {
            this.handlerCheck(this.state.value, false);
        } else if (!empty(this.state.defaultValue)) {
            this.handlerCheck(this.state.defaultValue, false);
        }

    }


    /**
     * 输入参数 nextProps 是即将被设置的属性，
     * 旧的属性还是可以通过 this.props 来获取。
     * 在这个回调函数里面，你可以根据属性的变化，
     * 通过调用 this.setState() 来更新你的组件状态，这里调用更新状态是安全的，
     * 并不会触发额外的 render() 调用
     */
    componentWillReceiveProps(nextProps) {
        $.extend(this.state, nextProps);

        if (nextProps.value != this.props.value) {
            this.handlerCheck(nextProps.value);
        }
    }


    render() {
        return (
            <div className="c-calendar">
                <div className="c-calendar-flex">
                    {this.renderYear()}
                    {this.renderMonth()}
                </div>
                {this.renderWeek()}
                <div className="c-calendar-inner">
                    {this.renderDay()}
                </div>
            </div>

        );
    }

    getDays() {
        let days1 = [];
        let days2 = [];
        let days3 = [];

        let year = ~~this.state.year;//年
        let month = ~~this.state.month;//月


        let datetime = strtotime(`${this.state.year}-${this.state.month}-${this.state.day}`);

        let m_first_time = strtotime(`${year}-${month}-01 00:00:00`, datetime); //本月第一天
        let t = date('t', m_first_time);//本月共有多少天
        let m_f_w = parseInt(date('w', m_first_time));//本月第一天是周几

        let m_last_time = strtotime(`-1 day`, datetime); //上个月最后一天
        let m_l_t = date('t', m_last_time);//上一个月共多少天


        if (m_f_w == 0) {
            m_f_w = 7
        }

        // 上个月
        for (let i = m_f_w - 1; i > 0; i--) {
            days1.push({
                day: m_l_t - i + 1,
                disabled: true
            });
        }


        var max = strtotime(this.props.max);
        var min = strtotime(this.props.min);

        var betweenMax = false;
        var betweenMin = false;

        if (!empty(this.props.between)) {
            betweenMax = strtotime(this.props.between[0]);
            betweenMin = strtotime(this.props.between[1]);
        }

        //添加日期
        for (let i = 1; i <= t; i++) {


            let value = date('Y-m-d', strtotime(`${i - 1} day`, m_first_time));

            let day = i;

            let data = {
                month,
                year,
                day,
                between: false,
                disabled: false,
                active: false,
                reference: false,
                datetime: strtotime(value)
            };


            //最小日期
            if (min > 0) {
                if (min > data.datetime) {
                    data.disabled = true;
                }
            }

            // 最大日期
            if (max > 0) {
                if (max < data.datetime) {
                    data.disabled = true;
                }
            }

            if (betweenMax > 0 && betweenMin > 0 && betweenMax <= data.datetime && betweenMin >= data.datetime) {
                data.between = true;
            }

            //最小日期
            if (this.props.min !== false) {
                if (this.props.min > data.datetime) {
                    data.disabled = true;
                }
            }

            // 最大日期
            if (this.props.max !== false) {
                if (this.props.max < data.datetime) {
                    data.disabled = true;
                }
            }

            let {selected} = this.state;

            if (!data.disabled && selected) {
                if (selected.year == year && selected.month == month && selected.day == day) {
                    data.active = true;
                } else if (selected.day == day) {
                    data.reference = true;
                }
            }

            //
            days2.push(data);
        }

        var next = 42 - date.length;

        // 下个月
        for (var i = 0; i < next; i++) {
            days3.push({
                day: i + 1,
                disabled: true
            })
        }
        return [].concat(days1, days2, days3);
    }

    /**
     *
     */
    renderDay() {
        var days = this.getDays();
        //console.log(days)
        var views = [];
        for (var i = 0; i < 6; i++) {
            views.push(
                <div key={i} className="c-calendar-days">
                    {this.renderWeekDay(days.slice(i * 7, (i + 1) * 7))}
                </div>
            )
        }
        return views;
    }

    /**
     *
     * @param days
     * @param index
     * @returns {Array}
     * @private
     */
    renderWeekDay(days, index) {
        var views = [];
        $.each(days, (i, day) => {
            views.push(
                <div
                    key={i}
                    className={classnames('c-calendar-day', {
                        'c-calendar-day-disabled': day.disabled,
                        'hover': !day.disabled && !day.active,
                        'c-calendar-day-selected': day.active,
                        'c-calendar-day-reference': day.reference,
                        'c-calendar-day-between': day.between
                    })}
                    onClick={() => {
                        if (!day.disabled) {
                            this.setState({
                                selected: {
                                    day: day.day,
                                    month: day.month,
                                    year: day.year
                                },
                                day: day.day
                            }, () => {
                                this.handlerValueChange()
                            });
                        }
                    }}
                    data-year={day.year}
                    data-month={day.month}
                    data-day={day.day}
                >
                    <div>
                        {day.day}
                    </div>
                </div>
            )
        });
        return views;
    }

    /**
     *
     * @return {*}
     */
    renderWeek() {
        let views = [];
        $.each(lang.days, (i, week) => {
            views.push(<Lang lang={week} key={i}/>)
        })
        return (
            <div className="c-calendar-week btn-group">
                {views}
            </div>
        )
    }

    /**
     *
     * @return {*}
     */
    renderYear() {
        return (
            <div className="c-calendar-year btn-group">
                <button color={4} onClick={e => {
                    this.state.year--;
                    this.forceUpdate()
                }}>
                    &lt;
                </button>
                <button color={4}>
                    <span ref="year-title">{this.state.year}</span>
                    <Lang lang="c.datetime.year"/>
                </button>
                <button color={4} onClick={e => {
                    this.state.year++;
                    this.forceUpdate()
                }}>
                    &gt;
                </button>
            </div>
        );
    }

    /**
     *
     * @return {*}
     */
    renderMonth() {
        return (
            <div className="c-calendar-month btn-group">
                <button color={4} onClick={e => {
                    if (this.state.month == 1) {
                        this.state.month = 12;
                        this.state.year--
                    } else {
                        this.state.month--;
                    }
                    this.forceUpdate();
                }}>
                    &lt;
                </button>
                <button color={4}>
                    <Lang lang={lang.months[this.state.month - 1]}/>
                </button>
                <button color={4} onClick={(e) => {
                    if (this.state.month == 12) {
                        this.state.month = 1;
                        this.state.year++
                    } else {
                        this.state.month++;
                    }
                    this.forceUpdate();
                }}>
                    &gt;
                </button>
            </div>
        )
    }

    /**
     *
     */
    handlerValueChange = () => {
        if (this.state.selected) {
            let datetime = strtotime(`${this.state.selected.year}-${this.state.selected.month}-${this.state.selected.day}`)
            let val = date(this.state.format, datetime);
            this.props.onValueChange && this.props.onValueChange(val);
        }
    }


    /**
     *
     */
    get value() {
        if (this.state.selected) {
            let datetime = strtotime(`${this.state.selected.year}-${this.state.selected.month}-${this.state.selected.day}`)
            let val = date(this.state.format, datetime);
            return val;
        } else {
            return '';
        }
    }

    /**
     *
     * @param value
     */
    set value(value) {
        this.handlerCheck(value)
    }

    /**
     *
     * @return {number}
     */
    get year() {
        return this.state.year;
    }

    /**
     *
     * @param year
     */
    set year(year) {
        this.setState({year})
    }

    /**
     *
     * @return {number}
     */
    get month() {
        return this.state.month;
    }

    /**
     *
     * @param month
     */
    set month(month) {
        this.setState({month})
    }

    /**
     *
     * @return {number}
     */
    get day() {
        return this.state.day;
    }

    /**
     *
     * @param day
     */
    set day(day) {
        this.setState({day, selected: {year: this.state.year, month: this.state.month, day: this.state.day}})
    }


    /**
     *
     * @param value
     * @param flag
     */
    handlerCheck = (value, flag = true) => {
        if (!empty(value)) {
            let datetime = strtotime(value) || 0;
            if (datetime > 0) {
                let year = ~~date('Y', datetime);
                let month = ~~date('m', datetime);
                let day = ~~date('d', datetime);
                if (!this.state.selected || this.state.selected.year != year || this.state.selected.month != month || this.state.selected.day != day) {
                    this.setState({year, month, selected: {year, month, day}}, () => {
                        if (flag)
                            this.handlerValueChange()
                    })
                } else {
                    this.setState({year, month})
                }
            } else {
                this.setState({selected: null})
            }
        } else {
            this.setState({selected: null})
        }
    }
}

Calendar.displayName = "Calendar";
Calendar.propTypes = {
    value: PropTypes.string,
    max: PropTypes.number,
    min: PropTypes.number,
    between: PropTypes.array,
    onValueChange: PropTypes.func
}
Calendar.pickProps = {
    value: 1,
    max: 1,
    min: 1,
    between: 1,
    onValueChange: 1
}

export default Calendar;
